import React from "react";
import { useTranslation } from "./hooks/useTranslation";
import { Button } from "./Button";
const Bookend = ({ title }) => {
    return (React.createElement("div", { className: "bookend" },
        React.createElement("span", { className: "bookend-circle" }),
        React.createElement("span", { className: "bookend-title" }, title)));
};
export const LearningPath = ({ children, }) => {
    const t = useTranslation();
    return (React.createElement("div", { className: "LearningPath" },
        React.createElement(Bookend, { title: t("Start") }),
        React.createElement("ul", { className: "learning-path-ul" }, children),
        React.createElement(Bookend, { title: t("End") })));
};
export const LearningPathActions = ({ children }) => (React.createElement("li", { className: "learning-path-li learning-path--actions" },
    React.createElement("div", null, children)));
export const LearningPathPagination = ({ totalNextPageRecords, onClick, disabled, id }) => {
    return (React.createElement("li", { className: "learning-path--pagination" },
        React.createElement("span", { className: "glyphicon-pro glyphicon-pro-squares" }),
        React.createElement(Button, { label: `Show more${totalNextPageRecords ? ` (${totalNextPageRecords})` : ""}`, onClick: onClick, type: "default", disabled: disabled, id: id })));
};
